import { Component, Input } from '@angular/core';

import { MessageDialogOptions, MessageDialogOptionsButton, MessageDialogService } from './message-dialog.service';

/**
 * Component that shows a default modal dialog box
 */
@Component({
    selector: 'cw-message-dialog',
    templateUrl: 'message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    standalone: false,
})
export class MessageDialogComponent {
    /** Options to customize the modal dialog box */
    @Input() options: Partial<MessageDialogOptions> = {};

    isAdditionalCheckboxSelected = false;

    constructor(private messageDialogService: MessageDialogService) {}

    buttonClick(button: MessageDialogOptionsButton): void {
        button.isAdditionalCheckboxSelected = this.isAdditionalCheckboxSelected;
        this.messageDialogService.buttonClick(button);
    }

    get contentHeaderClass(): string {
        return this.options.messageType === 'information' ? '' : `twc-message-box-${this.options.messageType}`;
    }
}
